export default __webpack_public_path__ + "static/media/IMG25.4fc9f21d.jpeg";